

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  wrapper: function wrapper(props) {
    return {
      display: 'block',
      position: 'relative',
      margin: {
        bottom: props.validationPassed === false && '1rem'
      },
      cursor: props.disabled === true && 'not-allowed'
    };
  },
  checkbox: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clippath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  },
  icon: {
    verticalAlign: 'middle'
  },
  labelText: function labelText(props) {return {
      verticalAlign: 'middle',
      margin: {
        left: '1.1rem'
      },
      font: {
        family: ['Lato', 'sans-serif'],
        lineHeight: '2.4rem',
        size: '1.6rem',
        weight: props.highlightColor ? 700 : 400
      },
      letterSpacing: '0.02rem',
      color:
      props.disabled === true ?
      colors.neutral[400] :
      props.highlightColor || (
      props.validationPassed === false ? colors.red[500] : colors.neutral[900])
    };},
  disabled: {
    cursor: 'not-allowed'
  },
  validationBlock: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem'
    },
    color: colors.blue[600],
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0'
  },
  validationMessage: {
    marginLeft: '0.4rem'
  },
  checkboxGuideline: {
    maxWidth: '100%'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map